var _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDangerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 7.83334H6.00016C5.6335 7.83334 5.3335 8.13334 5.3335 8.5C5.3335 8.86667 5.6335 9.16667 6.00016 9.16667H10.0002C10.3668 9.16667 10.6668 8.86667 10.6668 8.5C10.6668 8.13334 10.3668 7.83334 10.0002 7.83334ZM8.00016 13.8333C5.0595 13.8333 2.66683 11.4407 2.66683 8.5C2.66683 5.55934 5.0595 3.16667 8.00016 3.16667C10.9408 3.16667 13.3335 5.55934 13.3335 8.5C13.3335 11.4407 10.9408 13.8333 8.00016 13.8333ZM8.00016 1.83334C4.32416 1.83334 1.3335 4.824 1.3335 8.5C1.3335 12.176 4.32416 15.1667 8.00016 15.1667C11.6762 15.1667 14.6668 12.176 14.6668 8.5C14.6668 4.824 11.6762 1.83334 8.00016 1.83334Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 7.83334H6.00016C5.6335 7.83334 5.3335 8.13334 5.3335 8.5C5.3335 8.86667 5.6335 9.16667 6.00016 9.16667H10.0002C10.3668 9.16667 10.6668 8.86667 10.6668 8.5C10.6668 8.13334 10.3668 7.83334 10.0002 7.83334ZM8.00016 13.8333C5.0595 13.8333 2.66683 11.4407 2.66683 8.5C2.66683 5.55934 5.0595 3.16667 8.00016 3.16667C10.9408 3.16667 13.3335 5.55934 13.3335 8.5C13.3335 11.4407 10.9408 13.8333 8.00016 13.8333ZM8.00016 1.83334C4.32416 1.83334 1.3335 4.824 1.3335 8.5C1.3335 12.176 4.32416 15.1667 8.00016 15.1667C11.6762 15.1667 14.6668 12.176 14.6668 8.5C14.6668 4.824 11.6762 1.83334 8.00016 1.83334Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/dangerIcon.62a4e70343ea13463fcbc1cbaea85a72.svg";
export { ForwardRef as ReactComponent };